import { spacing } from '@rentivo/gatsby-core/src/containers/ThemeProvider/theme/foundation/spacing';

const largeSizes = {
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
};

const container = {
  "sm": "576px",
  "md": "768px",
  "lg": "992px",
  "xl": "1200px",
  "full": "100%"
};

const sizes = {
  ...spacing,
  ...largeSizes,
  container,
};

export default sizes;
